import React from 'react';
import { Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'; // Removed Paper
import SmsIcon from '@mui/icons-material/Sms';
import GlassCard from '../../../ui/glass/components/GlassCard';

const CommunicationLogCard = ({ communicationLog }) => {
    if (communicationLog.length === 0) return null;

    return (
        <GlassCard sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>İletişim Geçmişi</Typography>
            <List dense>
                {communicationLog.map(log => (
                    <ListItem key={log.id}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>
                            <SmsIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={`[${log.type}] ${log.status}`}
                            secondary={
                                <>
                                    <Typography component="span" variant="body2" color="text.primary">
                                        {log.timestamp?.toDate().toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' })}
                                    </Typography>
                                    {" — "}{log.content}
                                </>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </GlassCard>
    );
};

export default CommunicationLogCard;
